import { Link, MenuItem, Stack, Typography } from '@mui/material';
import { useLocales } from '../../locales';
import MenuPopover from './menu-popover';
import Iconify from './iconify';
import { useState } from 'react';
import Image from './image';

export default function LanguageSelection({ color, variant = 'body1', sx }) {
    const { allLangs, currentLang, onChangeLang } = useLocales();
    const [openPopover, setOpenPopover] = useState(null);

    const handleOpenPopover = (event) => {
        setOpenPopover(event.currentTarget);
    };

    const handleClosePopover = () => {
        setOpenPopover(null);
    };

    const handleChangeLang = (newLang) => {
        onChangeLang(newLang);
        handleClosePopover();
    };

    return (
        <>
            <Link
                onClick={handleOpenPopover}
                color={color}
                sx={{ cursor: 'pointer', display: 'flex', alignItems: 'center', ...sx }}
            >
                <Iconify icon="bi:translate" width={18} sx={{ mr: 0.5 }} />
                <Typography variant={variant}>
                    {currentLang.label}
                </Typography>
                <Iconify icon="eva:chevron-down-fill" width={16} sx={{ ml: 0.5 }} />
            </Link>

            <MenuPopover
                open={openPopover}
                onClose={handleClosePopover}
                sx={{ width: 160 }}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                arrow="bottom-center"
            >
                <Stack spacing={0.5}>
                    {allLangs.map((option) => (
                        <MenuItem
                            key={option.value}
                            selected={option.value === currentLang.value}
                            onClick={() => handleChangeLang(option.value)}
                            sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}
                        >
                            <Image
                                disabledEffect
                                alt={option.label}
                                src={option.icon}
                                sx={{ width: 24 }}
                            />
                            <div>{option.label}</div>
                        </MenuItem>
                    ))}
                </Stack>
            </MenuPopover>
        </>
    );
} 